import { render, staticRenderFns } from "./LessonComponent.vue?vue&type=template&id=385bd70a&scoped=true&"
import script from "./LessonComponent.vue?vue&type=script&lang=js&"
export * from "./LessonComponent.vue?vue&type=script&lang=js&"
import style0 from "./LessonComponent.vue?vue&type=style&index=0&id=385bd70a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385bd70a",
  null
  
)

export default component.exports